// A photo from the tablet's camera, as the base64 Manufacturing's build issues take.

export const MAX_PHOTO_BYTES = 5 * 1024 * 1024;
export const PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'] as const;

export interface EncodedPhoto {
    readonly base64: string;
    readonly contentType: string;
    readonly name: string;
}

/** Reads a photo as base64, refusing a type or size the API would refuse. */
export async function encodePhoto(file: File): Promise<EncodedPhoto> {
    if (!(PHOTO_TYPES as readonly string[]).includes(file.type)) {
        throw new Error('A photo must be a JPEG, PNG, WebP or GIF image.');
    }
    if (file.size > MAX_PHOTO_BYTES) {
        throw new Error('A photo must be under 5 MB.');
    }
    const buffer = new Uint8Array(await file.arrayBuffer());
    let binary = '';
    for (let index = 0; index < buffer.length; index += 0x8000) {
        binary += String.fromCharCode(...buffer.subarray(index, index + 0x8000));
    }
    return { base64: btoa(binary), contentType: file.type, name: file.name };
}
